// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.App-header {
  background-color: #2c3e50;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.App-header h1 {
  margin: 0;
  font-size: 1.5rem;
}

.App-nav {
  display: flex;
  gap: 1.5rem;
}

.App-nav a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
}

.App-nav a:hover {
  opacity: 0.8;
}

.App-main {
  flex: 1 1;
  padding: 2rem;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .App-header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .App-header h1 {
    font-size: 1.2rem;
    text-align: center;
  }

  .App-nav {
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  .App-nav a {
    font-size: 0.9rem;
  }

  .App-main {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .App-header h1 {
    font-size: 1rem;
  }

  .App-nav {
    gap: 0.75rem;
  }

  .App-nav a {
    font-size: 0.85rem;
    padding: 0.25rem 0.5rem;
  }

  .App-main {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.App-header {\n  background-color: #2c3e50;\n  color: white;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.App-header h1 {\n  margin: 0;\n  font-size: 1.5rem;\n}\n\n.App-nav {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.App-nav a {\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  transition: opacity 0.2s;\n}\n\n.App-nav a:hover {\n  opacity: 0.8;\n}\n\n.App-main {\n  flex: 1;\n  padding: 2rem;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .App-header {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .App-header h1 {\n    font-size: 1.2rem;\n    text-align: center;\n  }\n\n  .App-nav {\n    gap: 1rem;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .App-nav a {\n    font-size: 0.9rem;\n  }\n\n  .App-main {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .App-header h1 {\n    font-size: 1rem;\n  }\n\n  .App-nav {\n    gap: 0.75rem;\n  }\n\n  .App-nav a {\n    font-size: 0.85rem;\n    padding: 0.25rem 0.5rem;\n  }\n\n  .App-main {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
